<!--视频播放-->
<template>
	<div class="onlineCameraBody">
		<!--<cameraTree slot="tree" :dataList="cameraTree" :maxSelectedNum="9" @checkItem="checkItem($event)" @beyondMaxSelect="beyondMaxSelect"></cameraTree>-->
		<elCameraTree :dataList="cameraTree" @checkItem="checkItem"></elCameraTree>
		<div slot="body" class="container">
			<div class="player" v-for="(video, index) in nowVideoList" :style="videoStyle(index)" :id="'player' + video.id" :key='index'></div>
		</div>
	</div>
</template>

<script>
	import Chimee from 'chimee'
	import hls from 'chimee-kernel-hls'
	import cameraTree from '@/components/module/tree/cameraTree.vue'
	import treeBody from '@/components/module/slotModule/treeBody.vue'
	import elCameraTree from '@/components/module/tree/elCameraTree.vue'
	export default {
		components: {
			cameraTree,
			treeBody,
			elCameraTree,
		},
		props: {},
		data() {
			return {
				player: undefined,
				cameraTree: [],
				nowVideoList: [], //当前要播放的摄像头
				nowCameraId: undefined,
			}
		},
		created() {},
		mounted() {
			debugPage = this
			//获取最新的摄像头树
			this.$api.cameraApi.getCameraTree(respon => {
				if (respon != undefined) {
					//加入pkid
					respon.map((item,index)=>{
						item.pkid=randomPkid()
						if(!isempty(item.next)){
							item.next.map((list)=>{
								list.pkid=randomPkid()
							})
						}
					})
					this.cameraTree = respon
				}
			})
		},
		destroyed() {},
		computed: {
			getBackgroudImageStyle() {
				return this.$store.resourcesStore.getters.getBackgroudImageStyle
			},
			getResourcesByName() {
				return this.$store.resourcesStore.getters.getResourcesByName
			},
			videoStyle() {
				return index => {
					switch(this.nowVideoList.length){
						case 1:
							return {
								'width':'100%',
								'height':'100%'
							}
						case 2:
							return {
								'width':'100%',
								'height':'50%'
							}
						case 3:
							if(index < 2){
								return {
									'width':'50%',
									'height':'50%'
								}
							}
							return {
								'width':'100%',
								'height':'50%'
							}
						case 4:
							return {
								'width':'50%',
								'height':'50%'
							}
						case 5:
							if(index == 0){
								return {
									'width':'75%',
									'height':'100%'
								}
							}
							return {
								'width':'25%',
								'height':'25%'
							}
						case 6:
							return {
								'width':'33.33%',
								'height':'50%'
							}
						case 7:
							if(index == 0){
								return {
									'width':'75%',
									'height':'66%'
								}
							}else if(index == 1 || index == 2){
								return {
									'width':'25%',
									'height':'33%'
								}
							}
							return {
								'width':'25%',
								'height':'34%'
							}
						case 8:
							return {
								'width':'25%',
								'height':'50%'
							}
						case 9:
							return {
								'width':'33.33%',
								'height':'33.33%'
							}
					}
				}
			}
		},
		watch: {
			
		},
		methods: {
			checkItem(list) {
				console.log(list,66666666666666)
				this.nowVideoList = list
				setTimeout(()=>{
					list.forEach(item => {
						this.player = new Chimee({
							wrapper: '#player'+item.id,
							src: '',
							controls: true,
							autoplay: true,
							kernels: {
								hls
							}
						})
						
						var videoIp = item.liveip
						var cameraId = this.getCameraId(videoIp)
						if (cameraId != undefined) {
							//是海康威视专用接口，需要调用接口获取对应id的临时播放地址
							this.loadIP(cameraId)
						}else{
							this.player.load(videoIp)
						}
					})
				},500)
			},
			beyondMaxSelect() {
				this.$dialogMethod.showMessage('最多可选择显示九个摄像头画面！')
			},
			loadIP(cameraId) {
				this.nowCameraId = cameraId
				this.$api.hikvisonApi.getCameraUrlById(cameraId, respon => {
					if (isempty(respon.data)) {
						this.$dialogMethod.showMessage("摄像头预览流获取失败!")
					} else {
						if (respon.cameraId != this.nowCameraId) {
							//切换到其他摄像头了，不管
							return
						}
						this.player.load(respon.data.url)
					}
				})
			},
			getCameraId(videoIp) {
				//判断是不是海康专用的地址，如果不是就返回undefined
				if (videoIp.startsWith('HIKVISIONCameraId=')) {
					return videoIp.substring('HIKVISIONCameraId='.length)
				}
			}
		}
	}
</script>

<style scoped>
	.container{
		border-top: solid 2px #808080;
		border-left: solid 2px #808080;
		overflow: hidden;
		background-color: #000000;
		width: 100%;
		height: 100%;
		overflow: hidden;
	}
	.player {
		float: left;
		box-sizing: border-box;
		border-right: solid 2px #808080;
		border-bottom: solid 2px #808080;
	}
	.onlineCameraBody{
		width: 100%;
		display: flex !important;
		align-items: center;
		justify-content: space-between;
		background-color: white;
	}
</style>
